'use client';

import Image from 'next/image';
import Link from 'next/link';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

export default function ShortCut() {
  const { teamSlug, cardName, externalLinks } = useTeamConfig();

  return (
    <div className="flex w-full gap-2">
      {/* First column - Point Lounge Link */}
      <div className="flex w-[calc(50%-4px)] flex-col items-center justify-center gap-2">
        <ShortCutLink href={`/${teamSlug}/point-lounge/use`}>
          <span className="typo-body-4 z-10 text-g-00">
            포인트로 인기상품
            <br />
            응모하기
          </span>
          <div className="absolute right-1 bottom-1 z-10">
            <Image
              src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/main/product.webp`}
              alt="경품 아이콘"
              width={78}
              height={78}
              unoptimized
            />
          </div>
          {/* Main gradient effect */}
          <div className="absolute right-[-62px] bottom-[-73px] h-[189px] w-[223px] bg-shortcut-glow-main blur-[4.4px]" />
        </ShortCutLink>
      </div>

      {/* Second column - Mini Game & Card Purchase */}
      <div className="flex w-[calc(50%-4px)] flex-col items-center justify-center gap-2">
        <ShortCutLink href={`/${teamSlug}/mini-game`}>
          <span className="typo-body-4 z-10 text-g-00">
            미니게임하고
            <br />
            포인트 받기
          </span>
          <div className="relative z-10 flex h-full flex-col justify-end">
            <Image
              src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_clay_minigame.webp`}
              alt="Mini Game Icon"
              width={38}
              height={38}
            />
          </div>
          {/* Sub gradient effect */}
          <div className="absolute right-[-56px] bottom-[-21px] h-[83px] w-[142px] bg-shortcut-glow-sub blur-[3.49px]" />
        </ShortCutLink>

        <ShortCutLink
          href={externalLinks.shopUrl}
          isExternal={!externalLinks.shopUrl.startsWith('/')}
          disabled={!externalLinks.shopUrl}
        >
          <span className="typo-body-4 z-10 whitespace-pre-line text-g-00">
            {`${cardName}\n구매하기`}
          </span>
          <div className="relative z-10 flex h-full flex-col justify-end">
            <Image
              src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_clay_card.webp`}
              alt="Card Icon"
              width={38}
              height={38}
            />
          </div>
          {/* Sub gradient effect */}
          <div className="absolute right-[-56px] bottom-[-21px] h-[83px] w-[142px] bg-shortcut-glow-sub blur-[3.49px]" />
        </ShortCutLink>
      </div>
    </div>
  );
}

interface ShortCutLinkProps {
  href: string;
  isExternal?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

function ShortCutLink({ href, isExternal = false, disabled = false, children }: ShortCutLinkProps) {
  const linkClassName = `
    flex w-full h-full p-3 justify-between items-start gap-1
    rounded-lg bg-white/20 backdrop-blur-[5px] overflow-hidden
    gradient-border gradient-border-shortcut
    ${disabled ? 'opacity-20 pointer-events-none' : ''}
  `;

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} className={linkClassName}>
      {children}
    </Link>
  );
}
